import { REHYDRATE } from "redux-persist";

import {
  initState,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  CHANGE_SUBJECT,
} from "constants";
import { AUTHORITIES } from "constants";

export default (state = initState, action) => {
  switch (action.type) {
    case REHYDRATE:
      if (action.payload) {
        return (state = {
          ...state,
          ...action.payload.authentication,
        });
      }
      return state;
    case LOGIN_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        pending: false,
        userData: action.payload,
        isAuthenticated: true,
        initialRoles:action.payload.authorities,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        pending: false,
        isAuthenticated: false,
      };
    case LOGOUT_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case LOGOUT_SUCCESS:
      return {
        ...initState
      };
    case LOGOUT_FAILURE:
      return {
        ...state,
        pending: false,
        isAuthenticated: false,
        error: true,
      };
    case CHANGE_SUBJECT:
      return {
        ...state,
        subjectData: {
          ...action.payload,
          forPersonOib: action.payload.forPersonOib === "null" ? null : action.payload.forPersonOib,
        },
      };
    case AUTHORITIES:
      return {
        ...state,
        userData:{
          ...state.userData,
          authorities: action.payload,
        }
      }
    default:
      return state;
  }
};
